"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Toolbar = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
var _DownloadButton = require("../DownloadButton");
var _FullscreenButton = require("../FullscreenButton");
var _Overview = require("../Overview");
var _PageNavigator = require("../PageNavigator");
var _Share = require("../Share");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 *  Top section of the catalogue.
 *  It contains Share, Download, PageNavigator and Overview components.
 */ const Toolbar = exports.Toolbar = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { config: { downloadEnabled, sharingPageEnabled } } = (0, _hooks.useConfiguration)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        role: "toolbar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.ActionsContainer, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Overview.Overview, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PageNavigator.PageNavigator, {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.ActionsContainer, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FullscreenButton.FullscreenButton, {}),
                    downloadEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DownloadButton.DownloadButton, {}) : null,
                    sharingPageEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Share.ShareButton, {}) : null
                ]
            })
        ]
    });
});
